import {requestContext} from '../../../common/requestContext';

export function getSafeAreaPaddingClassName(padding: 'top' | 'bottom') {
  if (
    requestContext.requestInfo.display.isWebView &&
    requestContext.requestInfo.display.isIos
  ) {
    return padding === 'top' ? 'pt-safe' : 'pb-safe';
  }

  return undefined;
}
